import { render, staticRenderFns } from "./AdminStudentUploadResult.vue?vue&type=template&id=d8800944&scoped=true"
import script from "./AdminStudentUploadResult.vue?vue&type=script&lang=js"
export * from "./AdminStudentUploadResult.vue?vue&type=script&lang=js"
import style0 from "./AdminStudentUploadResult.vue?vue&type=style&index=0&id=d8800944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8800944",
  null
  
)

export default component.exports